<template>
  <div class="container-fluid">
    <div class="align-right-div">
      <button class="btn btn-secondary reset-filter-button" @click="resetFilters(); viewTriggers++;">
        <i class="fa fa-retweet"/>
        <template>
          {{ $t('shopfloor.teamlead.orderHandling.resetFilter') }}
        </template>
      </button>
      <button class="btn btn-secondary" @click="filterOpen = !filterOpen">
        <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"/>
        <template v-if="!filterOpen">
          {{ $t('shopfloor.teamlead.orderHandling.openFilter') }}
        </template>
        <template v-else>
          {{ $t('shopfloor.teamlead.orderHandling.closeFilter') }}
        </template>
      </button>
    </div>
    <div class="row dataTable-filters orderlines-dt-filter" :class="filterOpenClass">
      <!-- DATE -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.orderHandling.fromDate') }}</label>
        <datepicker
            monday-first
            :language="nl"
            :format="dateDisplay"
            v-model="fromDate"
            :disabled-dates="getDisabledDatesFrom"
            @selected="selectedDateChanged"
            id="fromDate" input-class="form-control "/>
      </div>
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.orderHandling.toDate') }}</label>
        <datepicker
            monday-first
            :language="nl"
            :format="dateDisplay"
            v-model="toDate"
            :disabled-dates="getDisabledDatesTo"
            @selected="selectedDateChanged"
            id="toDate" input-class="form-control "/>
      </div>
      <!-- State -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.orderHandling.states.title') }}</label>
        <div class="option-wrapper">
          <div class="custom-control custom-checkbox"
               v-for="(state, index) in uniqueStates"
               :key="state+'-'+index">
            <input v-model="customFilters[3].options.values"
                   :value="state"
                   type="checkbox"
                   :id="'state-'+index"
                   class="custom-control-input"
            >
            <label class="custom-control-label" :for="'state-'+index">
              <div class="state-filter">
                <span>{{ $t(`shopfloor.teamlead.orderHandling.states.${currentView}.${state}`) }}</span>
                <div class="circle" v-bind:class="'status-' + currentView  +'-' + state"></div>
              </div>
            </label>
          </div>
        </div>
      </div>

    </div>
    <div v-if="currentView === 'unloading'" class="selection-buttons">
      <button :disabled="getAmountToSelectLeft() < 0 || !selectedRows.length || saving" class="btn btn-primary"
              :class="saving === 'manco' ? 'blink-button' : ''"
              @click="handleSelectedRows('manco')">
        {{
          $t(saving === 'manco' ? 'shopfloor.teamlead.orderHandling.actions.manco.busy' : 'shopfloor.teamlead.orderHandling.buttons.declareDefect')
        }}
      </button>
      <button :disabled="selectedDoneRows() || getAmountToSelectLeft() < 0 || !selectedRows.length || saving"
              class="btn btn-primary"
              :class="saving === 'unload' ? 'blink-button' : ''"
              @click="handleSelectedRows('unload')">
        {{ $t('shopfloor.teamlead.orderHandling.buttons.unload') }}

      </button>
    </div>
    <div class="table-responsive">
      <datatables
          :columns="getColumns()"
          ref="orderHandlingTable"
          :rows="getProductsWithCargoAndOrder"
          :tableClass="tableClass"
          :tableInitOptions="tableInitOptions"
          deleteClass="delete"
          :key="currentView + '-' + selectedDate.toJSON() + '-' + viewTriggers"
          :customFilters="customFilters"
          tableID="cargo-handling-dt"
          v-if="getProductsWithCargoAndOrder"
      />
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';
import dataTables from '../../mixins/datatables';
import Datepicker from 'vuejs-datepicker';
import {nl} from 'vuejs-datepicker/dist/locale';


export default {
  name: 'teamlead-cargo-handling-tvat',
  components: {Datepicker},
  mixins: [dataTables],
  data() {
    return {
      bc: null,
      saving: null,
      masterCheckbox: undefined,
      selectedRows: [],
      viewTriggers: 0,
      maxSelectedWithoutFilter: 200,
      currentView: 'loading',
      nl: nl,
      defaultSelected: {
        truck: undefined,
        trailer: undefined,
        date: undefined
      },
      fromDate: moment().subtract(30, 'day').toDate(),
      toDate: new Date(),
      searchTruck: '',
      searchCustomer: '',
      searchTrailerNumber: '',
      selectedDate: moment().toDate(),
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      tableClass: 'table-striped table-bordered     responsive nowrap',
      tableInitOptions: {
        stateSave: true,
        language: {
          "lengthMenu": "_MENU_ resultaten weergeven",
          "zeroRecords": "Geen resultaten gevonden",
          "infoEmpty": "Geen resultaten om weer te geven",
          "search": "Zoeken:",
          "emptyTable": "Geen resultaten aanwezig in de tabel",
          "infoThousands": ".",
          "loadingRecords": "Een moment geduld aub - bezig met laden...",
          "paginate": {
            "first": "Eerste",
            "last": "Laatste",
            "next": "Volgende",
            "previous": "Vorige"
          },
          "aria": {
            "sortAscending": ": activeer om kolom oplopend te sorteren",
            "sortDescending": ": activeer om kolom aflopend te sorteren"
          },
          "autoFill": {
            "fill": "Vul alle cellen met <i>%d</i>",
            "fillHorizontal": "Vul cellen horizontaal",
            "fillVertical": "Vul cellen verticaal"
          },
          "buttons": {
            "collection": "Collectie",
            "colvis": "Kolom zichtbaarheid",
            "colvisRestore": "Herstel zichtbaarheid",
            "copy": "Kopieer",
            "copySuccess": {
              "1": "1 regel naar klembord gekopieerd",
              "_": "%ds regels naar klembord gekopieerd"
            },
            "copyTitle": "Kopieer naar klembord",
            "csv": "CSV",
            "excel": "Excel",
            "pageLength": {
              "-1": "Toon alle regels",
              "_": "Toon %d regels"
            },
            "pdf": "PDF",
            "print": "Print"
          },
          "info": "_START_ tot _END_ van _TOTAL_ regels",
          "infoFiltered": " (gefilterd uit _MAX_ regels)",
          "processing": "Verwerken..."
        },
        select: true,
        pageLength: 25,
        order: [[this.currentView === 'loading' ? 2 : 3, 'desc']]
      },
      customFilters: []
    };
  },
  computed: {
    ...mapGetters('orderProducts', ['getProductsWithCargoAndOrderOutgoing']),
    ...mapGetters('incomingOrderProducts', ['getProductsWithCargoAndOrderIncoming', 'getProduct']),
    ...mapGetters('customers', ['getCustomers']),
    ...mapGetters('users', ['getMeBasic']),
    ...mapGetters('batchUnload', ['getBatchUnloads']),
    ...mapGetters('deviationFixerQueue', ['getDeviationFixerQueue']),
    ...mapGetters('incomingOrders', ['getOrders']),
    getDisabledDatesFrom() {
      let ultimateToDate = moment(this.toDate).isAfter(moment(this.selectedDate).subtract(30, 'day')) ? moment(this.toDate) : moment(this.selectedDate).subtract(30, 'day')
      return { to: moment(this.selectedDate).subtract(30, 'day').toDate(), from:  ultimateToDate.toDate()}
    },
    getDisabledDatesTo() {
    let ultimateFromDate = moment(this.fromDate).isSameOrAfter(moment(this.selectedDate).subtract(30, 'day')) ? moment(this.fromDate) : moment(this.selectedDate).subtract(30, 'day')
      return { to: ultimateFromDate.toDate(), from:  moment(this.selectedDate).toDate()}
    },
    getProductsWithCargoAndOrder() {
      const groupedData = _.map(_.groupBy(this.getProductsWithCargoAndOrderOutgoing, 'cargoNumber'), grouped => {
        const ordersFullyLoaded =  _.filter(grouped, g => { return g.amountLoaded  && g.amountLoaded >= g.amount }).length;
        const ordersLoading = _.filter(grouped, g => { return g.amountLoaded  && g.amountLoaded > 1 }).length;
        let state = (!ordersLoading && !ordersFullyLoaded) ? 'idle' : (ordersFullyLoaded < grouped.length ? 'busy' : 'done')
        return {
          cargoNumber: _.first(grouped).cargoNumber,
          cargoId: _.first(grouped).cargoId,
          estimatedTimeOfDeparture: _.first(grouped).estimatedTimeOfDeparture,
          orderProducts: grouped,
          ordersFullyLoaded,
          ordersLoading,
          state
        }
      });
      console.log(groupedData)
      return _.filter(groupedData, cargo => {
        if(cargo.cargoNumber == 1542286){
          console.log(cargo)
        }
        return cargo.orderProducts.length && moment(cargo.estimatedTimeOfDeparture ? cargo.estimatedTimeOfDeparture.toDate() : new Date()).isBetween(this.fromDate,  this.toDate, 'date', '[]')
      })
    },
    searchByTruck() {
      return _.uniq(_.map(this.getProductsWithCargoAndOrder.filter((product) => {
        return product.truckNumber && `${product.truckNumber}`.toLowerCase().indexOf(`${this.searchTruck}`.toLowerCase()) >= 0;
      }), 'truckNumber')).sort(this.sortCaseInsensitive);
    },
    searchByCustomerName() {
      return _.uniq(_.map(this.getProductsWithCargoAndOrder.filter((product) => {
        return product.customer && `${product.customer}`.toLowerCase().indexOf(`${this.searchCustomer}`.toLowerCase()) >= 0;
      }), 'customer')).sort(this.sortCaseInsensitive);
    },
    searchByTrailerNumber() {
      return _.uniq(_.map(this.getProductsWithCargoAndOrder.filter((product) => {
        return product.trailerNumber && `${product.trailerNumber}`.toLowerCase().indexOf(`${this.searchTrailerNumber}`.toLowerCase()) >= 0;
      }), 'trailerNumber')).sort(this.sortCaseInsensitive);
    },
    uniqueStates() {
      return ['idle', 'busy', 'done'];
    }
  },
  methods: {
    ...mapActions('incomingOrderProducts', [
      'updateAmountLocally'
    ]),
    openCargo(cargoId) {
      this.$router.push({
        path: '/loading/cargo/' + cargoId
      })
    },
    selectedDateChanged(params) {
      sessionStorage.setItem('cargoHandlingDate', moment(params).format('YYYY-MM-DD'));
    },
    create_UUID() {
      let dt = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    handleSelectedRows(action) {
      const html = this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.message').replace('[AMOUNT]', `<b>${this.selectedRows.length}</b>`)
      this.$swal({
        customClass: 'm-swal-load-unload',
        width: '80%',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: true,
        title: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.title'),
        html,
        cancelButtonColor: '#d33',
        showConfirmButton: true,
        confirmButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.confirm'),
        cancelButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.cancel')
      }).then(async result => {
        if (result.value) {
          if (action === 'manco') {
            this.saving = 'manco';
            const guids = [];
            let amountToUnloadTotal = 1;
            for (let i = 0; i < this.selectedRows.length; i++) {
              const incomingProduct = this.getProduct(this.selectedRows[i]);
              if (incomingProduct.amountUnloaded == undefined || incomingProduct.amountUnloaded < incomingProduct.amount) {
                let amountToUnload = incomingProduct.amount - (incomingProduct.amountUnloaded ? incomingProduct.amountUnloaded : 0);
                amountToUnloadTotal += amountToUnload;
                const date = new Date();
                const deviationIds = [];
                for (let i = 0; i < amountToUnload; i++) {
                  let deviation = {
                    amount: 1,
                    companyId: this.getMeBasic.companyId,
                    location: 'unloading',
                    created_at: date,
                    locationAdditional: incomingProduct.productNumber,
                    userId: this.getMeBasic.userId,
                    userName: this.getMeBasic.userName,
                    // recordId: incomingProduct.id,
                    orderId: incomingProduct.incomingOrderId,
                    remark: 'Gemeld via orderafhandeling',
                    type: 'shortage'
                  }
                  const devRes = await this.$FB.collection('deviations').add(deviation);
                  deviationIds.push(devRes.id);
                }
                if (deviationIds.length) {
                  let guid = this.create_UUID();
                  guids.push(guid);
                  await this.$FB.collection('deviation-fixer-queue').add({
                    amount: amountToUnload,
                    deviationIds: deviationIds,
                    companyId: this.getMeBasic.companyId,
                    location: 'unloading',
                    guid,
                    packingListNumber: incomingProduct.packingListNumber,
                    uniqueIncomingProductIndex: incomingProduct.uniqueIndex,
                    created_at: date,
                    locationAdditional: incomingProduct.productNumber,
                    userId: this.getMeBasic.userId,
                    userName: this.getMeBasic.userName,
                    recordId: incomingProduct.id,
                    orderId: incomingProduct.incomingOrderId,
                    remark: 'Gemeld via orderafhandeling',
                    type: 'shortage'
                  });
                }
              }
            }
            this.deselectAllRows();

            const doneInterval = setInterval(() => {
              let allDone = true;
              for (let i = 0; i < guids.length; i++) {
                if (this.getDeviationFixerQueue.indexOf(guids[i]) > -1) {
                  allDone = false;
                }
              }
              if (allDone) {
                clearInterval(doneInterval);
                setTimeout(() => {
                  this.saving = null;
                  this.$swal({
                    position: 'bottom-end',
                    icon: 'success',
                    title: this.$root.$t('shopfloor.teamlead.orderHandling.actions.manco.done'),
                    showConfirmButton: false,
                    timer: 2000
                  });
                }, amountToUnloadTotal * 1000);
              }
            }, 500);
          } else if (action === 'unload') {
            this.saving = 'unload';
            let promises = []
            const guids = [];
            for (let i = 0; i < this.selectedRows.length; i++) {
              const incomingProduct = this.getProduct(this.selectedRows[i]);
              // if (incomingProduct.amountUnloaded == undefined || incomingProduct.amountUnloaded < incomingProduct.amount) {
              let guid = this.create_UUID();
              guids.push(guid);
              promises.push(this.$FB.collection('batch-unload').add({
                companyId: this.getMeBasic.companyId,
                endTime: new Date(),
                locationId: this.getMeBasic.companyId === 7 ? 1042 : 123456789,
                guid,
                barcodeUnreadable: true,
                startTime: new Date(),
                userId: this.getMeBasic.userId,
                userName: this.getMeBasic.userName,
                dateFrom: moment(this.selectedDate).startOf('day').toDate(),
                dateTo: moment(this.selectedDate).endOf('day').toDate(),
                type: {
                  value: incomingProduct.id,
                  key: 'id',
                }
              }))
              // await this.$FB.collection('batch-unload').add({
              //   companyId: this.getMeBasic.companyId,
              //   endTime: new Date(),
              //   locationId: 1042,
              //   guid,
              //   barcodeUnreadable: true,
              //   startTime: new Date(),
              //   userId: this.getMeBasic.userId,
              //   userName: this.getMeBasic.userName,
              //   dateFrom: moment(this.selectedDate).startOf('day').toDate(),
              //   dateTo: moment(this.selectedDate).endOf('day').toDate(),
              //   type: {
              //     value: incomingProduct.id,
              //     key: 'id',
              //   }
              // });
              // }
            }
            Promise.all(promises)
            this.deselectAllRows();
            this.$swal({
              toast: true,
              position: 'bottom-end',
              icon: 'success',
              html: this.$root.$t('shopfloor.teamlead.orderHandling.actions.unload.done'),
              showConfirmButton: false,

            });
            const doneInterval = setInterval(() => {
              let allDone = true;
              for (let i = 0; i < guids.length; i++) {
                if (this.getBatchUnloads.indexOf(guids[i]) > -1) {
                  allDone = false;
                }
              }
              if (allDone) {
                clearInterval(doneInterval);

                this.saving = null;


              }
            }, 500);
          }
        }
      });
    },
    selectedDoneRows() {
      const selectedProducts = _.filter(this.getProductsWithCargoAndOrder, (product) => {
        return _.indexOf(this.selectedRows, product.id) > -1;
      });
      // const selectedProducts = this.getProductsWithCargoAndOrder.filter(product => {
      //   return this.selectedRows.indexOf(product.id) > -1;
      // });
      return _.findIndex(selectedProducts, { 'state': 'done' }) > -1;
      // return selectedProducts.findIndex(selectedProduct => {
      //   return selectedProduct.state === 'done';
      // }) > -1;
    },
    getAmountToSelectLeft() {
      const allFiltersExceptDate = this.customFilters.filter(customFilter => customFilter.filter !== "dateRangeFilter");
      let allEmptyFilters = allFiltersExceptDate.filter(customFilter => customFilter.options.values.length === 0);

      // If state filter has busy and idle selected: we consider as 'no filter'
      const stateFilter = this.customFilters.find(customFilter => customFilter.keyToFilter === 'state');
      if (stateFilter.options.values.indexOf('idle') > -1 && stateFilter.options.values.indexOf('busy') > -1) {
        allEmptyFilters.push(stateFilter);
      }

      if (allFiltersExceptDate.length === allEmptyFilters.length) {
        return this.maxSelectedWithoutFilter - this.selectedRows.length;
      } else {
        return undefined;
      }
    },
    showSelectionLimitPopUp() {
      return this.$swal({
        title: this.$root.$t('shopfloor.teamlead.orderHandling.maxSelected.title'),
        text: this.$root.$t('shopfloor.teamlead.orderHandling.maxSelected.message'),
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.maxSelected.closeButton'),
        reverseButtons: true
      })
    },
    dateDisplay(date) {
      return moment(date).format('DD/MM/YY');
    },
    sortCaseInsensitive(a, b) {
      return `${a}`.toLowerCase().localeCompare(`${b}`.toLowerCase());
    },
    async openOrderProductsDBChannel(date) {
      let skipCloseDB = false;
      if (!date) {
        if (this.defaultSelected.date) {
          date = moment(this.defaultSelected.date.toDate());
          this.selectedDate = this.defaultSelected.date.toDate();
          this.defaultSelected.date = undefined;
        } else {
          date = moment();
        }
        skipCloseDB = true;
      }
      if (!skipCloseDB) {
        if (this.currentView === 'loading') {
          await this.$store.dispatch('orderProducts/closeDBChannel', {clearModule: true});
          await this.$store.dispatch('orders/closeDBChannel', {clearModule: true});
        }
        if (this.currentView === 'unloading') {
          await this.$store.dispatch('incomingOrderProducts/closeDBChannel', {clearModule: true})
          await this.$store.dispatch('incomingOrders/closeDBChannel', {clearModule: true});
        }
      }

      if (this.currentView === 'loading') {
        let where = [['companyId', '==', this.getMeBasic.companyId], ['estimatedTimeOfDeparture', '>=', date.clone().startOf('day').subtract(30, 'day').toDate()], ['estimatedTimeOfDeparture', '<=', date.clone().endOf('day').toDate()]]
        await this.$store.dispatch('orders/openDBChannel', {where})
        await this.$store.dispatch('orderProducts/openDBChannel', {where});
      }
      if (this.currentView === 'unloading') {
        let where = [['companyId', '==', this.getMeBasic.companyId], ['estimatedTimeOfArrival', '>=', date.clone().startOf('day').subtract(30, 'day').toDate()], ['estimatedTimeOfArrival', '<=', date.clone().endOf('day').toDate()]]
        await this.$store.dispatch('incomingOrders/openDBChannel', {where})
        await this.$store.dispatch('incomingOrderProducts/openDBChannel', {where});
      }
      this.$store.commit('setLoading', false)
      this.viewTriggers++;
    },
    getColumns() {
      let self = this;
      return ([
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.cargoNumber'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return `<a class="dt-router-link" href="javascript:window.VueGlobalEventBus.$emit('openCargo', { cargoId: ${data.cargoId}})" data-to="/loading/cargo/${data.cargoId}">${data.cargoNumber ? data.cargoNumber : ''}</a>`
          }
        },
        {
          data: this.currentView === 'loading' ? 'estimatedTimeOfDeparture' : 'estimatedTimeOfArrival',
          name: this.$t('shopfloor.teamlead.orderHandling.date.' + this.currentView),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return moment(data.toDate()).format('DD/MM  HH:mm');
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.state'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data, type) {
            if (type === 'sort') {
              return data.state
            }
            return `<div class="circle status-${self.currentView}-${data.state}"></div>`;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.progress'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            return `${data.ordersFullyLoaded} / ${data.orderProducts.length}`;
          }
        }
      ]);
    },
    async closeView(to) {
      const store = this.currentView === 'loading' ? ['orders', 'orderProducts'] : (!to || (to.name !== 'teamlead-cargos-unloading' && to.name !== 'unloaded') ? ['incomingOrderProducts'] : []).concat(['incomingOrders', 'deviationFixerQueue', 'batchUnload']);
      return this.$store.dispatch('resetStoreModules', store).catch(console.error);
    },
    resetFilters() {
      const defaultTruckFilter = [];
      const defaultTrailerFilter = [];
      if (this.defaultSelected.trailer) {
        defaultTrailerFilter.push(this.defaultSelected.trailer);
        this.defaultSelected.trailer = undefined;
      }
      if (this.defaultSelected.truck) {
        defaultTruckFilter.push(this.defaultSelected.truck);
        this.defaultSelected.truck = undefined;
      }
      this.customFilters = [
        {
          filter: 'arrayContains',
          keyToFilter: 'truckNumber',
          options: {
            values: defaultTruckFilter
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'customer',
          options: {
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'trailerNumber',
          options: {
            values: defaultTrailerFilter
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'state',
          options: {
            values: ['done', 'busy', 'idle']
          }
        }
      ];
      this.searchTrailerNumber = '';
      this.searchTruck = '';
      this.searchCustomer = '';
      this.selectedRows = [];
    },
    async createView() {
      this.selectedRows = [];
      this.selectedDate = moment().toDate();
      this.resetFilters();
      // this.currentView = this.$route.meta['view'];
      this.currentView = localStorage.getItem('orderhandling-view')

      const store = this.currentView === 'loading' ? [] : ['deviationFixerQueue', 'batchUnload'];
      let where = [['companyId', '==', this.getMeBasic.companyId]]
      for (let i = 0; i < store.length; i++) {
        await this.$store.dispatch(store[i] + '/openDBChannel', {where})
      }
      return this.openOrderProductsDBChannel();
    }
  },
  watch: {
    filterOpen: function (filter) {
      if (filter) {
        this.filterOpenClass = 'm-show-flex-lg';
      } else {
        this.filterOpenClass = 'm-hide-lg';
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (to.name !== 'teamlead-cargo-handling-loading' && to.name !== 'teamlead-cargo-handling-unloading') {
      window.VueGlobalEventBus.$off('barcodeClicked');
    }
    await this.closeView(to);
    next();
  },
  created() {
    window.VueGlobalEventBus.$off('openCargo');
    window.VueGlobalEventBus.$on('openCargo', (params) => {
      this.openCargo(params.cargoId);
    });

    const filteredDateFrom = sessionStorage.getItem('cargoHandlingDateFrom');
    const filteredDateTo = sessionStorage.getItem('cargoHandlingDateTo');

    if (filteredDateFrom) {
      this.fromDate = moment(filteredDateFrom).toDate();
    }
    if (filteredDateTo) {
      this.toDate = moment(filteredDateTo).toDate();
    }

    window.VueGlobalEventBus.$on('barcodeClicked', (data) => {
      return this.$router.push({name: 'TrackAndTrace', params: { productNumber: data }});
    });
    window.VueGlobalEventBus.$on('OpenDeviations', (data) => {
      if (this.currentView === 'loading') {
        this.$router.push({
          name: 'teamlead-deviations-loading',
          params: {recordId: data}
        });
      } else {
        this.$router.push({
          name: 'teamlead-deviations-unloading',
          params: {recordId: data}
        });
      }
    });
    this.$store.commit('setLoading', true)
    if (!localStorage.getItem('orderhandling-view')) {
      if (this.$route.params && this.$route.params.cargo && this.$route.params.cargo.cargoType === 'incoming') {
        localStorage.setItem('orderhandling-view', 'unloading')
        this.$globalEventBus.$emit('orderhandling-view-changed', 'unloading');
      } else {
        localStorage.setItem('orderhandling-view', 'loading');
        this.$globalEventBus.$emit('orderhandling-view-changed', 'loading');
      }
    } else {
      if (this.$route.params && this.$route.params.cargo) {
        if (this.$route.params.cargo.cargoType === 'incoming') {
          localStorage.setItem('orderhandling-view', 'unloading');
          this.$globalEventBus.$emit('orderhandling-view-changed', 'unloading');
        } else {
          localStorage.setItem('orderhandling-view', 'loading');
          this.$globalEventBus.$emit('orderhandling-view-changed', 'loading');
        }
      }
    }

    if (this.$route.params && this.$route.params.cargo) {
      this.defaultSelected.trailer = this.$route.params.cargo.trailerNumber;
      this.defaultSelected.truck = this.$route.params.cargo.truckNumber;
      this.defaultSelected.date = this.$route.params.cargo.estimatedTimeOfArrival ? this.$route.params.cargo.estimatedTimeOfArrival : this.$route.params.cargo.estimatedTimeOfDeparture;
    }
    this.createView();
  }
};
</script>


<style lang="scss">
.status-loading-idle {
  background-color: #ffa0a0;
}

.status-loading-busy {
  background-color: #ffaf46;
}

.status-loading-done {
  background-color: #00b954;
}


.status-unloading-idle {
  background-color: white;
  border: 1px solid black !important;
}

.status-unloading-busy {
  background-color: gray;
}

.status-unloading-done {
  background-color: #00c9ff;
}

.circle {
  width: 2rem;
  height: 2rem;
  border: 1px solid white;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
}

.align-right-div {
  text-align: right;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.state-filter {
  display: grid;
  grid-template-columns: 13rem 2rem;;
  grid-template-rows: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
}

.selection-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.dataTable-filters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  margin: 1rem;
}

.m-hide-lg {
  visibility: hidden;
  height: 0px;
}

.container-fluid {
  margin-bottom: 15px;
}

.reset-filter-button {
  margin-right: 1rem;
}

.blink-button {
  -webkit-animation: blink 5s infinite; /* Safari 4+ */
  -moz-animation: blink 5s infinite; /* Fx 5+ */
  -o-animation: blink 5s infinite; /* Opera 12+ */
  animation: blink 5s infinite; /* IE 10+, Fx 29+ */
}

.deviation-present {
  color: red;
  font-weight: bold;
  font-size: 1.8rem;
  cursor: pointer;
}

.packingListNumber {
  align-self: center;
}

.deviationPresentContainer {
  display: grid;
  grid-template-columns: 1fr 90px;
  grid-template-rows: 1fr 0px;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
}


</style>
<style>
.break-usernames {
  word-break: normal;
  white-space: normal !important;
}
</style>